<template>
  <div>
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button v-auth="`EXPORT`"  v-waves class="filter-search-item" type="primary" @click="dialogVisibleFun">导出</vxe-button>
        <vxe-button v-auth="`ADD`"  v-waves class="filter-search-item" type="primary" @click="goAdd">新增</vxe-button>
        <vxe-button v-auth="`BATCHIMPORT`"  v-waves class="filter-search-item" type="primary" @click="uploadDialog = true">批量导入</vxe-button>
        <vxe-button v-auth="`EXPORTTIPSDEALER`"  v-waves class="filter-search-item" type="primary" @click="exportTipsDealer">未提报商家信息</vxe-button>
        <vxe-button v-auth="`BATCHIMPORT`"  v-waves class="filter-search-item" type="primary" @click="handleImportDealerVisible">批量导入经销商</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showFilter">
            <a-input v-model="queryCondition.planCodeOrName" placeholder="输入活动名称/活动计划编码" clearable style="width: 200px; margin-right: 1rem;height:28px" @keyup.enter.native="allActivity(1)" />
          </div>
          <div>
            <vxe-button v-if="!showFilter" status="primary"  class="filter-search-item" @click="allActivity(1)">搜索</vxe-button>
            <vxe-button v-if="!showFilter"  class="filter-search-item" @click="resetForm()">重置</vxe-button>
            <vxe-button  @click="cb">
              {{ showFilter ? '收起' : '更多选项' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--  高级筛选折叠-->
      <div style="margin-top: 20px">
        <a-collapse>
          <div v-show="showFilter">
            <SiftActivity :data="queryCondition" />
            <br>
            <div slot="footer" style="text-align: center; padding-bottom: 15px">
              <vxe-button  @click="resetForm">重置</vxe-button>
              <vxe-button status="primary"  @click="allActivity(1)">搜索</vxe-button>
            </div>
          </div>
        </a-collapse>
      </div>
      <vxe-toolbar ref="toolbarRef" custom style="height:39px;margin-top:-10px;background: #F3F4F7;" />
      <vxe-table
        id="toolbar_maintainact"
        ref="xTable"
        :loading="listLoading"
        border
        show-header-overflow
        show-overflow
        align="center"
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :custom-config="{storage: true}"
        :row-config="{ isCurrent: true, isHover: true }"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        :scroll-y="{ enabled: false }"
        :data="tableData"
        @cell-dblclick="cellClickEvent"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column field="planCode" title="活动计划编码" width="160" />
        <vxe-column field="actName" title="活动名称" width="200" />
        <vxe-column field="budgetTypeName" title="预算类型" width="120" />
        <vxe-column field="oneLevelName" title="一级来源" width="160" />
        <vxe-column field="twoLevelName" title="二级来源" width="160" />
        <vxe-column field="threeLevelName" title="三级来源" width="160" />
        <!-- <vxe-column field="fourLevelName" title="四级来源" width="160" /> -->
        <!-- <vxe-column field="fiveLevelName" title="五级来源" width="160" /> -->
        <vxe-column field="planStartTime" title="生效时间" width="120">
          <template #default="{ row }">
            <span>{{ row.planStartTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column field="planEndTime" title="失效时间" width="120">
          <template #default="{ row }">
            <span>{{ row.planEndTime | dateFormat("yyyy-MM-dd") }}</span>
          </template>
        </vxe-column>
        <vxe-column field="createTime" title="创建时间" width="160" />
        <vxe-column field="createUserName" title="创建人" width="160" />
        <vxe-column prop="planStatus" title="状态" align="center" width="100">
          <template #default="{ row }">
            <span v-if="row.planStatus === '0'">待发布</span>
            <span v-else-if="row.planStatus === '1'">已发布</span>
            <span v-else>已失效</span>
          </template>
        </vxe-column>
        <!-- <vxe-column field="remarks" title="活动其他说明" width="160" /> -->
        <!-- <vxe-column field="writeOffRules" title="核销规则" width="160" /> -->
        <!-- <vxe-column field="writeOffMaterial" title="核销材料说明" width="160" /> -->
        <!-- <vxe-column field="writeOffOther" title="核销其他说明" width="160" /> -->
        <vxe-column title="操作" width="260" fixed="right" align="center">
          <template #default="{ row }">
            <div class="handle-box" style="height:30px">
              <a-button v-auth="`UPDATE`" v-if="row.planStatus == 0" type="link" @click="editEvent(row)">编辑</a-button>
              <a-button v-auth="`PUBLISH`" v-if="row.planStatus == 0" type="link" @click="publishEvent(row)">发布</a-button>
              <a-button type="link" v-auth="`VIEW`" @click="qurryDeta(row)">查看</a-button>
              <a-button v-auth="`DELETE`" v-if="row.planStatus == 0" type="link" @click="deleteRole(row)">删除</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        v-show="!listLoading"
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />

      <vxe-modal v-model="showDetails" title="查看详情" width="600" height="400" :mask="false" :lock-view="false" resize>
        <template #default>
          <vxe-table
            border="inner"
            auto-resize
            show-overflow
            height="auto"
            :row-config="{isHover: true}"
            :show-header="false"
            :sync-resize="showDetails"
            :data="detailData"
          >
            <vxe-column field="label" width="40%" />
            <vxe-column field="value" />
          </vxe-table>
        </template>
      </vxe-modal>
    </div>
    <!--导出对话框 -->
    <a-modal title="选择导出项" v-model="dialogVisible" width="400px">
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button size="small" @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button size="small" status="primary" :loading="outExcelButtonLocading" @click="handleDownload">确 定</vxe-button>
      </span>
    </a-modal>

    <!--导入对话框 -->
    <el-dialog title="导入Excel" :visible.sync="uploadDialog" width="400px" @close="uploadClose">
      <div :loading="importLoading" class="faultAdd">
        <div class="model-box">
          <!-- <a class="load-buttom" href="/file/活动下发导入模板v1.xlsx" download><i class="el-icon-download" />下载示例模板</a> -->
          <a class="load-buttom" @click="downloadTemplate"><i class="el-icon-download" />下载示例模板</a>
        </div>
        <el-upload ref="upload" class="upload-demo" drag action="" multiple :http-request="upload" :before-upload="uploadBefore" :file-list="fileList">
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">直接导入已填好的Excel列表，仅支持XLS/XLSX</div>
        </el-upload>
        <div v-if="errorList.length > 0" class="err-box">
          <el-link icon="el-icon-warning" type="danger">Excel导入出错，请检查错误行，然后将错误行重新导入</el-link>
          <div v-for="item in errorList" :key="item.row">
            <el-link type="danger">{{ item }}</el-link>
          </div>
        </div>
      </div>
    </el-dialog>

    <a-form-model ref="batchImportDealerFormRef" :model="dealerImportFormModel" label-width="0">
        <a-modal
            v-model="showBatchImportDealerDialog"
            title="批量导入经销商"
            width="1200px"
            centered
            :confirmLoading="submitBatchImportDealerLoading"
            @ok="handleSubmitBatchImportDealer"
            @cancel="showBatchImportDealerDialog = false"
        >
          <el-form :inline="true" style="margin: 0; height: auto; padding: 0 10px; vertical-align: middle">
            <SiftDealer :base="base">
              <template slot="ButtonTwo">
                <el-form-item style="margin: 10px">
                  <vxe-button style="background: #1b81ef; border: 0" status="primary" @click="handleQueryByPageInDealerImportDialog(1)">搜索</vxe-button>
                  <vxe-button  @click="handleClearDataInDealerImportDialog">重置</vxe-button>
                </el-form-item>
              </template>
            </SiftDealer>
          </el-form>
          <a-row :gutter="16" style="margin-bottom: 4px; line-height: 32px;">
            <a-col :span="2" style="align-items: center;margin-bottom: 0;margin-top: 2px">
              <a-button type="primary" @click="handleSetParamInBatchImportDealer">统一设置参数</a-button>
            </a-col>
            <a-col :span="6">
              <a-form-model-item
                  label="费用额度"
                  :label-col="{ span: 9 }"
                  :wrapper-col="{ span: 15 }"
                  style="margin-bottom: 0"
              >
                <a-input v-model="uniformSetParam.feeLimit" placeholder="额度"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item
                  label="核销比例"
                  :label-col="{ span: 9 }"
                  :wrapper-col="{ span: 15 }"
                  style="margin-bottom: 0"
              >
                <a-input v-model="uniformSetParam.writeRate" placeholder="比例"  @input="handleWriteRateInputInUniformSet()"/>
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item
                  label="执行频次"
                  :label-col="{ span: 9 }"
                  :wrapper-col="{ span: 15 }"
                  style="margin-bottom: 0"
              >
                <a-input v-model="uniformSetParam.executeFreq" placeholder="频次"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <vxe-table
              border
              stripe
              show-overflow
              align="center"
              header-align="center"
              :max-height="400"
              style="margin-top: 10px"
              class="mytable-scrollbar tableOvf"
              v-loading="dealerImportDataSearchLoading"
              :data="dealerImportFormModel.dealerImportTableData"
              :checkbox-config="{ highlight: true }"
              @checkbox-change="handleSelectInDealerImportDialog"
              @checkbox-all="handleSelectInDealerImportDialog"
          >
            <vxe-column type="checkbox" width="60" />
            <vxe-column type="seq" title="序号" width="60" />
            <vxe-column title="经销商名称" field="dealerName" />
            <vxe-column title="费用额度(元)" field="feeLimit" width="240">
              <template #default="{ row,$rowIndex }">
                <a-form-model-item
                    :prop="'dealerImportTableData.' + $rowIndex + '.feeLimit'"
                    :rules="row._checked ? [{ required: true, message: '请输入费用额度' }] : []"
                    style="margin:0"
                >
                  <a-input
                      v-model="row.feeLimit"
                      placeholder="请输入"
                      @input="e => row.feeLimit = e.target.value.replace(/[^\d]/g, '')"
                  />
                </a-form-model-item>
              </template>
            </vxe-column>

            <vxe-column title="核销比例(%)" field="writeRate" width="230">
              <template #default="{ row,$rowIndex }">
                <a-form-model-item
                    :prop="'dealerImportTableData.' + $rowIndex + '.writeRate'"
                    :rules="row._checked ? [{ required: true, message: '请输入核销比例' }] : []"
                    style="margin:0"
                >
                  <a-input
                      v-model="row.writeRate"
                      placeholder="请输入"
                      @input="handleWriteRateInput(row, 'writeRate')"
                  />
                </a-form-model-item>
              </template>
            </vxe-column>

            <vxe-column title="执行频次" field="executeFreq" width="230">
              <template #default="{ row,$rowIndex }">
                <a-form-model-item
                    :prop=" 'dealerImportTableData.' + $rowIndex + '.executeFreq'"
                    :rules="row._checked ? [{ required: true, message: '请输入执行频次' }] : []"
                    style="margin:0"
                >
                  <a-input
                      v-model="row.executeFreq"
                      placeholder="请输入"
                      @input="e => row.executeFreq = e.target.value.replace(/[^\d]/g, '')"
                  />
                </a-form-model-item>
              </template>
            </vxe-column>
          </vxe-table>
          <vxe-pager
              v-show="!dealerImportDataSearchLoading"
              :current-page="dealerImportPagination.current"
              :page-size="dealerImportPagination.size"
              :total="dealerImportPagination.total"
              :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 5000]"
              :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
              @page-change="changePageInDealerImportDialog"
          />
        </a-modal>
      </a-form-model>
  </div>
</template>

<script>
import {
  findList,
  deleteActPlan,
  exportActPlan,
  exportTipsDealer,
  uploadPlanBatch,
  exportActPlanTemp,
  saveBatchInDetails,
} from '@/api/actPlan'
// import permission from '@/directive/permission/index.js' // 权限判断指令
import waves from '@/directive/waves'
// import { outExcel } from '@/utils/Excel/outExcel'
import SiftActivity from './components/SiftActivity.vue'
import SiftDealer from "@/pages/web/terminalActivity/components/SiftDealer.vue";
import {findDealerListByPage} from "@/api/base-data";
import moment from "moment/moment";

const defaultPlanStatus = new Map([
  ['0', '待发布'],
  ['1', '已发布'],
  ['2', '已失效']
])

export default {
  // inject: ['reload'],
  name: 'MaintainActivity',
  directives: { waves },
  components: {SiftDealer, SiftActivity },
  data() {
    return {
      dialogVisible: false, // 导出对话框
      outExcelButtonLocading: false, // 按钮等待
      ExportItem: 0, // 导出选择
      disabled: false, // 已选择是否导出
      tableData: [],
      showDetails: false,
      detailData: [],
      planStatusMap: defaultPlanStatus,
      domain: 'center', // center,表示总部; dealer，表示经销商
      listLoading: false,
      fileList: [],
      uploadDialog: false,
      importLoading: false,
      errorList: [],
      modelTable: {
        // 数据
        data: [],
        loading: false,
        selection: []
      },
      sort: 'create_time desc',
      base: {      // 经销商导入对话框中的查询条件对应数据
        sectorId: null,
        provinceId: null,
        cityId: null,
        dealerName: null
      },
      dealerImportPagination: {   // 经销商导入对话框中的查询分页参数
        total: 0,
        size: 10,
        current: 1
      },
      dealerImportFormModel: {      //表单校验需要使用
        dealerImportTableData: []
      },
      showBatchImportDealerDialog: false,
      dealerImportDataSearchLoading: false,
      submitBatchImportDealerLoading: false,
      planIdListForImportDealer: [],
      uniformSetParam : {
        feeLimit: "",   // 费用额度
        writeRate: "",  // 核销比例
        executeFreq: "" // 执行频次
      }
    }
  },
  computed: {
    queryCondition() {
      return this.$store.state.actPlanListPage.queryCondition
    },
    pagination() {
      return this.$store.state.actPlanListPage.pagination
    },
    showFilter() {
      return this.$store.state.actPlanListPage.showFilter
    }
  },
  activated() {
    this.allActivity() // 活动维护初始化数据
    this.$nextTick(() => {
      this.$refs.xTable.connect(this.$refs.toolbarRef)
    })
  },
  created() {
    // if (this.$route.params) {
    //   this.queryCondition.planCodeOrName = this.$route.params.planCode
    // }
    this.allActivity() // 活动维护初始化数据
    this.$nextTick(() => {
      this.$refs.xTable.connect(this.$refs.toolbarRef)
    })
  },
  methods: {
    // 活动删除按钮
    deleteRole(row) {
      this.$confirm({
        title: '提示',
        content: '此操作将永久删除该活动, 是否继续?',
        onOk:() => {
          deleteActPlan(row.id).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          } else {
            this.$message(res.message)
          }
          this.allActivity()
        })
        },
        onCancel:() => {
          this.$message.info('已取消删除')
        },
      });
    },
    cellClickEvent({ row }) {
      this.detailData = [{
        field: 'planCode',
        title: '活动计划编码'
      },
      {
        field: 'actName',
        title: '活动名称'
      },
      {
        field: 'budgetTypeName',
        title: '预算类型'
      },
      {
        field: 'oneLevelName',
        title: '一级来源'
      },
      {
        field: 'twoLevelName',
        title: '二级来源'
      },
      {
        field: 'threeLevelName',
        title: '三级来源'
      },
    //  {
    //    field: 'fourLevelName',
    //    title: '四级来源'
    //  },
    //  {
    //    field: 'fiveLevelName',
    //    title: '五级来源'
    //  },
      {
        field: 'planStartTime',
        title: '生效时间'
      },
      {
        field: 'planEndTime',
        title: '失效时间'
      },
      {
        field: 'createTime',
        title: '创建时间'
      },
      {
        field: 'createUserName',
        title: '创建人'
      },
      {
        field: 'remarks',
        title: '活动其他说明'
      },
      {
        field: 'writeOffRules',
        title: '核销规则'
      },
      {
        field: 'writeOffMaterial',
        title: '核销材料说明'
      },
      {
        field: 'writeOffOther',
        title: '核销其他说明'
      },
      {
        field: 'planStatus',
        title: '状态'
      }].map(obj => {
        if (obj.field === 'planStatus') {
          return { label: obj.title, value: this.planStatusMap.get(row[obj.field]) }
        }
        return { label: obj.title, value: row[obj.field] }
      })
      this.showDetails = true
    },
    dialogVisibleFun() {
      if (this.domain === 'dealer') {
        this.$message.warning('经销商没有导出活动权限')
        return
      }
      this.ExportItem = 0
      this.disabled = this.$refs.xTable.selection.length < 1
      this.dialogVisible = true
    },
    // 新增跳转
    goAdd() {
      this.$router.push({ path: 'addActivity/null' })
    },
    // 重置筛选
    resetForm() {
      // 使用 Vuex 模块中的默认查询条件重置
      this.$store.commit('actPlanListPage/resetQueryCondition')
      this.allActivity()
    },
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      pageSize !== this.pagination.size && (this.pagination.current = 1)
      this.pagination.size = pageSize
      this.allActivity()
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },
    // 上传
    upload(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.importLoading = true
      uploadPlanBatch(formData).then(res => {
        if (res.code === 1) {
          this.importLoading = false
          this.$message.success('导入成功')
          this.uploadDialog = false
          this.allActivity()
          // this.reload()
        } else {
          this.errorList[0] = res.message
          this.importLoading = false
          this.$message.error(res.message)
        }
      })
    },
    cb() {
      this.$store.commit('actPlanListPage/updateShowFilter', !this.showFilter)
    },
    // 查询活动
    allActivity(e) {
      if (e) this.pagination.current = e
      // 保存查询条件到store
      this.$store.commit('actPlanListPage/updatePagination', this.pagination)
      this.$store.commit('actPlanListPage/updateQueryCondition', this.queryCondition)

      var data = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.queryCondition,
        sort: this.sort
      }
      this.listLoading = true // 开启加载动画
      findList(data).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error(res.message)
          this.listLoading = false
        }
      }).finally(()=> this.listLoading = false )
    },
    // 选择数据
    selectionChange(val) {
      this.modelTable.selection = val
    },
    // 导出
    async handleDownload() {
      this.outExcelButtonLocading = true
      let param = {}
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        param = {
          page: 1,
          limit: this.pagination.total,
          sort: this.sort,
          ...this.queryCondition
        }
      } else if (this.ExportItem == 1) {
        param = {
          page: this.pagination.current,
          limit: this.pagination.size,
          sort: this.sort,
          ...this.queryCondition
        }
      } else if (this.ExportItem == 2) {
        const idList = []
        this.$refs.xTable.selection.forEach(item => {
          idList.push(item.id)
        })
        param = {
          page: 1,
          limit: this.pagination.size,
          ids: idList,
          sort: this.sort,
          ...this.queryCondition
        }
      }
      exportActPlan(param).then(val => {
        this.$exportExcelData(val, `活动下发列表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
        this.dialogVisible = false
        this.outExcelButtonLocading = false
      })
    },
    exportTipsDealer() {
      if (this.$refs.xTable.selection.length < 1) {
        this.$message.warning('请至少勾选一条记录')
        return
      }
      const idList = []
      this.$refs.xTable.selection.forEach(item => {
        idList.push(item.id)
      })
      exportTipsDealer(idList).then(val => {
        this.$exportExcelData(val, `未提报商家信息表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
      })
    },
    publishEvent(row) {
      this.$router.push({
        path: `detailsActivity/${row.id}/publish`
      })
    },
    qurryDeta(row) {
      this.$router.push({
        path: `detailsActivity/${row.id}`
      })
    },
    // 获取修改id
    editEvent(row) {
      this.$router.push({
        path: `editActivity/${row.id}`
      })
    },
    // 下载导入模板
    downloadTemplate() {
      exportActPlanTemp({ tempType: '2' }).then(val => {
        this.$exportExcelData(val, '活动下发导入模板.xlsx')
      })
    },
    uploadClose() {
      this.errorList = []
      this.fileList = []
    },
    handleWriteRateInput(row, field) {  // 处理输入的核销比例，不能超过100
      let val = String(row[field] ?? '')
      val = val.replace(/[^\d]/g, '')   // 只留数字
      if (val && Number(val) > 100) val = '100'
      row[field] = val
    },
    handleWriteRateInputInUniformSet() {  // 处理输入的核销比例，不能超过100
      let val = this.uniformSetParam.writeRate
      val = val.replace(/[^\d]/g, '')   // 只留数字
      if (val && Number(val) > 100) val = '100'
      this.uniformSetParam.writeRate = val
    },
    handleImportDealerVisible() {
      // 先判断有无过期计划和有无勾选
      if (this.$refs.xTable.selection.length < 1) {
        this.$message.warning('请至少勾选一条记录')
        return
      }
      let flagIsPass = false
      this.planIdListForImportDealer = []
      const selection = this.$refs.xTable.selection
      for (const item of selection) {
        this.planIdListForImportDealer.push(item.id)
        if (moment(item.planEndTime).isSameOrBefore(moment().startOf('day'))) {
          this.$message.warning('活动计划编码：' + item.planCode + '已结束，不可导入经销商')
          flagIsPass = true
          break
        }
      }
      if (!flagIsPass) {
        this.handleQueryByPageInDealerImportDialog(1)
        // 判断通过再弹出选择框
        this.showBatchImportDealerDialog = true
      }

    },
    //  经销商批量导入页面，提交时调用
    handleSubmitBatchImportDealer() {
      const selectedRows = this.dealerImportFormModel.dealerImportTableData.filter(r => r._checked)
      if (!selectedRows.length) {
        this.$message.warning('请至少选择一家经销商')
        return
      }
      // 整表校验
      this.$refs.batchImportDealerFormRef.validate(valid => {
        if (!valid) {
          this.$message.warning('请先完善相关信息')
        } else {
          this.submitBatchImportDealerLoading = true
          this.dealerImportDataSearchLoading = true
          const data = {
            planIdList: this.planIdListForImportDealer,
            dealers: selectedRows
          }
          saveBatchInDetails(data).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              this.submitBatchImportDealerLoading = false
              this.dealerImportDataSearchLoading = false
              this.showBatchImportDealerDialog = false
            } else {
              this.$message.error(res.message)
              this.submitBatchImportDealerLoading = false
              this.dealerImportDataSearchLoading = false
            }
          })
        }
      })
    },
    //  经销商批量导入页面，查询经销商使用
    handleQueryByPageInDealerImportDialog(n) {
      this.dealerImportDataSearchLoading = true
      this.dealerImportFormModel.dealerImportTableData = []
      const param = {
        page: n,
        limit: this.dealerImportPagination.size,
        ...this.base
      }
      findDealerListByPage(param).then(res => {
        if (res.code === 1 && res.data) {
          this.dealerImportDataSearchLoading = false
          this.dealerImportFormModel.dealerImportTableData = res.data.records.map(item => ({
            ...item,
            _checked: false,
          }))
          this.dealerImportPagination.total = res.data.total
        }
      })
    },
    // 清除条件
    handleClearDataInDealerImportDialog() {
      this.base.sectorId = null
      this.base.provinceId = null
      this.base.cityId = null
      this.base.dealerName = null
      this.handleQueryByPageInDealerImportDialog(1)
    },
    // 经销商批量导入页面，分页变化时
    changePageInDealerImportDialog({ currentPage, pageSize }) {
      this.dealerImportPagination.current = currentPage
      pageSize !== this.dealerImportPagination.size && (this.dealerImportPagination.current = 1)
      this.dealerImportPagination.size = pageSize
      this.handleQueryByPageInDealerImportDialog(this.dealerImportPagination.current)
    },
    //  经销商批量导入页面，选择经销商时
    handleSelectInDealerImportDialog({ records }) {
      this.dealerImportFormModel.dealerImportTableData.forEach(row => { row._checked = false })
      records.forEach(row => { row._checked = true })
    },

    /** 统一设置按钮 */
    handleSetParamInBatchImportDealer() {
      // 空值不处理
      if (!this.uniformSetParam.feeLimit && !this.uniformSetParam.writeRate && !this.uniformSetParam.executeFreq) {
        return
      }
      const table = this.dealerImportFormModel.dealerImportTableData
      table.forEach((row) => {
        if (this.uniformSetParam.feeLimit)   this.$set(row, 'feeLimit',   this.uniformSetParam.feeLimit)
        if (this.uniformSetParam.writeRate)  this.$set(row, 'writeRate',  this.uniformSetParam.writeRate)
        if (this.uniformSetParam.executeFreq) this.$set(row, 'executeFreq', this.uniformSetParam.executeFreq)
      })
    },


  }
}
</script>

<style lang="less" scoped>
  /deep/ .ant-collapse {
    border: none;
    background-color: #fff;
  }
</style>
